<!--
  @修改人：谢汉
  @修改时间：2019-02-28
  @修改描述：新增查询、新增、更新站点字段
  @版本:v2.0.2
  --------
  @修改人：黎柏祺
  @修改时间：2018-11-28
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @修改人：谢汉
  @修改时间：2018-05-08
  @修改描述：新增表格描述字段
  @版本:v1.0.16
  --------
  @负责人: 谢汉
  @创建时间: 2018-01-18
  @版本:v1.0.12
  @描述: 指标配置页
  -->
  <template>
    <div class="kpiMapping__content">
      <div class="kpiMapping__form">
        <el-form ref="form" :model="form" :inline="true" label-width="auto" >
          <el-form-item :label="$t('kpiMapping.siteCode')">
            <g-select v-model="form.siteCode" :list="select_site" :defaultAll="true"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.group')">
            <g-select :list="select_group" v-model="form.group" :default-all="true"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.appName')">
            <g-select :list="select_appName" v-model="form.appName" :default-all="true"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.kpiKey')">
            <el-input v-model="form.kpiKey"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="e_searchKpi" v-g-rac="gRac('kpiMapping_search')">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="kpiMapping__operation">
        <el-button type="primary"  @click="e_add" v-g-rac="gRac('kpiMapping_add')">{{ $t('kpiMapping.create') }}</el-button>
        <el-button type="primary"  @click="cloneKpi" v-g-rac="gRac('kpiMapping@clone')">{{ $t('kpiMapping.clone') }}</el-button>
      </div>
      <div class="kpiMapping__table">
        <el-table-extend 
          :data="tData" 
          :head="tHead" 
          :currentChange="tCurrentChange" 
          :sizeChange="tSizeChange" 
          border>
          <template slot="control-column" slot-scope="{data}">
            <el-table-extend-control 
              :control="tableControl" 
              :data="data" 
              :label="$t('common.handle')">
            </el-table-extend-control>
          </template>
        </el-table-extend>
      </div>
      <el-dialog :closeOnClickModal="false" :title="$t('kpiMapping.cloneKpi')" :visible.sync="cloneFormVisible" width="700px">
        <div class="kpiMapping__dialog-body">
          <el-col :span="12">
            <div class="kpiMapping__dialog-title">{{$t('kpiMapping.origin')}}</div>
            <el-form :model="cloneForm" label-position="left" label-width="80px" ref="cloneFormA" :rules="cloneFromRules" >
              <el-form-item :label="$t('kpiMapping.siteCode')">
                <g-select v-model="cloneForm.sourceSiteCode" :list="select_site"></g-select>
              </el-form-item>
              <el-form-item :label="$t('kpiMapping.group')" prop="sourceGroup">
                <el-select v-model="cloneForm.sourceGroup">
                  <el-option :label="item" :value="index" v-for="(item,index) in select_sourceGroup" :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('kpiMapping.appName')" prop="sourceAppName">
                <el-select v-model="cloneForm.sourceAppName">
                  <el-option :label="item" :value="item" v-for="(item,index) in select_originAppName" :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('kpiMapping.kpiKey')">
                <g-select v-model="cloneForm.kpiKey" :list="select_kpiKey" :default-all="true"></g-select>
              </el-form-item>
              <el-form-item :label="$t('kpiMapping.cloneAlarm')" prop="cloneAlarm">
                <el-radio-group v-model="cloneForm.cloneAlarm">
                  <el-radio :label="index" v-for="(item,index) in enableList" :key="index">{{item}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <div class="kpiMapping__dialog-title">{{$t('kpiMapping.target')}}</div>
            <el-form :model="cloneForm" label-position="left" label-width="80px" ref="cloneFormB" :rules="cloneFromRules" >
              <el-form-item :label="$t('kpiMapping.siteCode')">
                <g-select v-model="cloneForm.targetSiteCode" :list="select_site"></g-select>
              </el-form-item>
              <el-form-item :label="$t('kpiMapping.group')" prop="targetGroup">
                <el-select v-model="cloneForm.targetGroup">
                  <el-option :label="item" :value="index" v-for="(item,index) in select_targetGroup" :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('kpiMapping.appName')" prop="targetAppName">
                <el-select v-model="cloneForm.targetAppName">
                  <el-option :label="item" :value="item" v-for="(item,index) in select_targetAppName" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm">{{$t('common.cancel')}}</el-button>
          <el-button type="primary" @click="isConfirmClone" v-g-rac="gRac('kpiMapping@clone')" >{{$t('kpiMapping.confirm')}}</el-button>
        </div>
      </el-dialog>
      <el-dialog :closeOnClickModal="false" :title="dialogTitle" :visible.sync="formVisible" width="1000px">
        <el-form :model="kpiForm" label-position="left" label-width="90px" ref="kpiForm" :rules="kpiFormRules">
          <el-form-item :label="$t('kpiMapping.siteCode')" prop="siteCode">
            <g-select v-model="kpiForm.siteCode" :list="select_site"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.group')" prop="group">
            <g-select v-model="kpiForm.group" :list="select_newGroup"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.appName')" prop="appName">
            <g-select v-model="kpiForm.appName" :list="select_newAppName"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.kpiType')" prop="kpiType">
            <g-select v-model="kpiForm.kpiType" :list="select_kpiType"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.kpiKey')" prop="kpiKey">
            <el-input v-model="kpiForm.kpiKey" ></el-input>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.status')" prop="categoryType">
            <g-select v-model="kpiForm.categoryType" :list="select_category"></g-select>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.isVisual')" prop="visual">
            <el-radio-group v-model="kpiForm.visual">
              <el-radio :label="index" v-for="(item,index) in select_visual" :key="index">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.describe')" prop="desc">
            <el-input v-model="kpiForm.desc" ></el-input>
          </el-form-item>
          <el-form-item :label="$t('kpiMapping.count')">
            <dynamic-table 
              ref="dynamicTable" 
              :input-data="dynamicData" 
              :model="dynamicModel" 
              :custom-fun="deleteDdatas"
              @selectChange="changeFormat">
            </dynamic-table>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetKpiForm">{{$t('common.cancel')}}</el-button>
          <el-button type="primary" @click="isConfirmSet" v-g-rac="gRac('kpiMapping_add')" >{{$t('kpiMapping.confirm')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
    import dic from '@/components/mixins/dic'
    import table from '@/components/mixins/table'
    import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz.js'
    import alarmSubscribeBiz from '@/logic/systemSetting/alarmSubscribeBiz.js'
    import SiteListBiz from '@/logic/cmdb/cmdbBiz'
    import rac from '@/plugins/rac-mixin.js'
    import dynamicTable from '@/components/dynamicTable'
    import { getKeyByValue, extend } from '@/utils/tool'
    export default {
      mixins: [dic, rac, table],
      data () {
        const that = this
        return {
          form: {
            siteCode: '',
            group: '',
            appName: ''
          },
          tableControl: [
            {
              label: that.$t('common.edit'),
              callback: that.e_update,
              rac: () => that.gRac('kpiMapping_amend')
            }, {
              label: that.$t('common.delete'),
              callback: that.e_delete,
              rac: () => that.gRac('kpiMapping_delete')
            }
          ],
          currentPage: 1,
          perPageCount: 10,
          cloneForm: {
            sourceSiteCode: '',
            targetSiteCode: '',
            sourceGroup: '',
            sourceAppName: '',
            kpiKey: '',
            cloneAlarm: '',
            targetGroup: '',
            targetAppName: ''
          },
          cloneFormVisible: false,
          cloneFromRules: {
            sourceAppName: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            sourceGroup: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            targetAppName: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            targetGroup: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            cloneAlarm: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ]
          },
          select_kpiType: {},
          select_appName: {},
          select_newGroup: {},
          select_newAppName: {},
          select_category: {},
          select_changeAppName: {},
          select_format: {},
          select_unit: {},
          select_alarmType: {},
          select_alarmName: {},
          select_sourceGroup: {},
          select_targetGroup: {},
          select_fields: {
            LONG: 'LONG',
            STRING: 'STRING'
          },
          select_visual: {
            '0': '',
            '1': ''
          },
          select_site: {},
          defaultAlarmIP: '',
          enableList: {},
          select_originAppName: {},
          select_kpiKey: {},
          select_targetAppName: {},
          defaultAll: true,
          isAmend: '',
          dialogTitle: '',
          formVisible: false,
          kpiFormRules: {
            siteCode: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            group: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            appName: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            kpiKey: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'blur' }
            ],
            kpiType: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            desc: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'blur' }
            ],
            visual: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ],
            categoryType: [
              { required: true, message: that.$t('kpiMapping.notEmpty'), trigger: 'change' }
            ]
          },
          select_allGroup: {},
          kpiForm: {
            siteCode: '',
            group: '',
            appName: '',
            visual: '',
            desc: '',
            kpiKey: '',
            kpiType: '',
            categoryType: '',
            fields: []
          },
          select_group: {},
          dynamicData: [],
          dynamicModel: {},
          selectId: ''
        }
      },
      computed: {
      },
      methods: {
        e_init () {
          this.select_visual['0'] = this.$t('kpiMapping.yes')
          this.select_visual['1'] = this.$t('kpiMapping.no')
          this.kpiForm.visual = '0'
          this.enableList = {
            yes: this.$t('kpiMapping.yes'),
            no: this.$t('kpiMapping.no')
          }
          this.waitKpiType()
          this.waitCategoryType()
          this.waitFormat()
          this.waitUnitType()
          this.waitAlarmType()
          this.getSiteList()
        },
        async waitGroupList (siteCode, siteChange, type) {
          await this.dGetGroup(siteCode, siteChange)
          switch (type) {
            case 1:
              if (siteCode === '') {
                this.select_allGroup = this.$store.state.dicModule.group
              }
              this.select_group = this.$store.state.dicModule.group
              this.form.appName = ''
              break
            case 2:
              this.select_newGroup = this.$store.state.dicModule.group
              this.kpiForm.group = ''
              this.kpiForm.appName = ''
              break
            case 3:
              this.select_sourceGroup = this.$store.state.dicModule.group
              this.cloneForm.sourceGroup = ''
              this.cloneForm.sourceAppName = ''
              break
            case 4:
              this.select_targetGroup = this.$store.state.dicModule.group
              this.cloneForm.targetGroup = ''
              this.cloneForm.targetAppName = ''
              break
            default:
          }
          setTimeout(() => {
            this.setDynamicData()
          }, 100)
        },
        async waitAppList (siteCode, val, type) {
          await this.dGetAppByGroup(siteCode, val)
          switch (type) {
            case 1:
              this.select_appName = { ...this.dDictionaryApp[val] }
              this.form.appName = ''
              break
            case 2:
              this.select_newAppName = { ...this.dDictionaryApp[val] }
              if (!this.isAmend) {
                this.kpiForm.appName = ''
              }
              break
            case 3:
              this.select_originAppName = { ...this.dDictionaryApp[val] }
              this.cloneForm.sourceAppName = ''
              break
            default:
              this.select_targetAppName = { ...this.dDictionaryApp[val] }
              this.cloneForm.targetAppName = ''
          }
        },
        async waitKpiType () {
          await this.dGetDictionaryByCode('kpiType')
          this.select_kpiType = { ...this.dDictionary.kpiType }
        },
        async waitCategoryType () {
          await this.dGetDictionaryByCode('categoryType')
          this.select_category = { ...this.dDictionary.categoryType }
        },
        async waitFormat () {
          await this.dGetDictionaryByCode('format')
          this.select_format = { ...this.dDictionary.format }
        },
        async waitUnitType () {
          await this.dGetDictionaryByCode('unitType')
          this.select_unit = { ...this.dDictionary.unitType }
        },
        async waitAlarmType () {
          await this.dGetDictionaryByCode('alarmType')
          this.select_alarmType = { ...this.dDictionary.alarmType }
        },
        getSiteList () {
          SiteListBiz.siteList({ perPageCount: 500 }).then((data) => {
            let list = {}
            data.dataList.map((item) => {
              list[item.siteCode] = item.name
            })
            this.select_site = list
            this.kpiForm.siteCode = Object.keys(this.select_site)[0]
            this.waitGroupList('', true, 1)
            setTimeout(() => {
              this.initTable()
              this.e_searchKpi()
            }, 1000)
          })
        },
        initTable () {
          this.tInitTable({
            lanKey: 'kpiMapping.table',
            head: ['siteCode', 'group', 'appName', 'kpiKey', 'desc'],
            requestFun: this.searchKpi,
            headOpt: {
              siteCode: {
                formatter: 'Dictionary',
                formatterDic: this.select_site
              },
              group: {
                formatter: 'Dictionary',
                formatterDic: this.select_allGroup
              }
            }
          })
        },
        setDynamicData () {
          this.dynamicData = [
            {
              label: this.$t('kpiMapping.x'),
              key: 'xName'
            },
            {
              label: this.$t('kpiMapping.xType'),
              key: 'xType',
              type: 'select',
              select: this.select_fields
            },
            {
              label: this.$t('kpiMapping.xDesc'),
              key: 'xDesc'
            },
            {
              label: this.$t('kpiMapping.y'),
              key: 'yName'
            },
            {
              label: this.$t('kpiMapping.yType'),
              key: 'yType',
              type: 'select',
              select: this.select_fields
            },
            {
              label: this.$t('kpiMapping.yDesc'),
              key: 'yDesc'
            },
            {
              label: this.$t('kpiMapping.type'),
              key: 'format',
              type: 'select',
              select: this.select_format
            },
            {
              label: this.$t('kpiMapping.chartUnit'),
              key: 'unit',
              type: 'select',
              select: {}
            }
          ]
          this.dynamicModel = {
            xName: '',
            xType: Object.keys(this.select_fields)[0],
            xDesc: '',
            yName: '',
            yType: Object.keys(this.select_fields)[0],
            yDesc: '',
            format: Object.keys(this.select_format)[0],
            unit: ''
          }
        },
        changeFormat (obj) {
          if (obj.item.format !== 'SIZE') {
            const data = this.$refs.dynamicTable.getData()
            this.$set(this.dynamicData[7], 'select', {})
            data[obj.index].unit = ''
            this.$refs.dynamicTable.setData(data)
          } else {
            const data = this.$refs.dynamicTable.getData()
            this.$set(this.dynamicData[7], 'select', this.select_unit)
            data[obj.index].unit = data[obj.index].unit === '' ? Object.keys(this.select_unit)[0] : data[obj.index].unit
            this.$refs.dynamicTable.setData(data)
          }
        },
        e_getKpiKey () {
          const info = {
            siteCode: this.cloneForm.sourceSiteCode,
            group: this.cloneForm.sourceGroup,
            appName: this.cloneForm.sourceAppName,
            currentPage: 1,
            perPageCount: 100
          }
          alarmSubscribeBiz.getKpiKey(info).then((data) => {
            const kpiKeyList = {}
            data.dataList.forEach((item, index) => {
              kpiKeyList[item.kpiKey] = item.desc
            })
            this.select_kpiKey = kpiKeyList
            this.cloneForm.kpiKey = ''
          })
        },
        searchKpi () {
          const reqData = extend(true, { ...this.tPageInfo }, this.form)
          systemSettingBiz.getKpi(reqData).then((data) => {
            this.tData = data
          })
        },
        e_searchKpi () {
          this.tResetPage()
          this.searchKpi()
        },
        e_update (data) {
          this.isAmend = true
          this.selectId = data.id
          Object.keys(this.kpiForm).forEach((item) => {
            this.kpiForm[item] = item !== 'group' ? data[item] : getKeyByValue(this.select_allGroup, data[item])
          })
          this.kpiForm.siteCode = Object.keys(this.select_site).filter(item => this.select_site[item] === data.siteCode)[0]
          this.formVisible = true
          this.$nextTick(() => {
            this.$refs.dynamicTable.setData(data.fields)
          })
        },
        e_delete (rowData) {
          this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }).then(() => {
            systemSettingBiz.deleteKpi({ id: rowData.id }).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              setTimeout(() => {
                this.searchKpi()
              }, 500)
            })
          }).catch(() => {})
        },
        deleteDdatas (item, i) {
          const d = this.$refs.dynamicTable.getData()
          if (d.length > 1) {
            d.splice(i, 1)
            this.$refs.dynamicTable.setData(d)
          }
        },
        resetForm () {
          this.$refs.cloneFormA.resetFields()
          this.$refs.cloneFormB.resetFields()
          this.cloneFormVisible = false
        },
        resetKpiForm () {
          this.formVisible = false
        },
        e_add () {
          this.isAmend = false
          this.formVisible = true
          let d = []
          d.push(this.dynamicModel)
          this.kpiForm = {
            siteCode: Object.keys(this.select_site)[0],
            group: '',
            appName: '',
            visual: '0',
            desc: '',
            kpiKey: '',
            kpiType: Object.keys(this.select_kpiType)[0],
            categoryType: Object.keys(this.select_category)[0],
            fields: []
          }
          this.$nextTick(() => {
            this.$refs.dynamicTable.setData(d)
          })
        },
        cloneKpi () {
          this.cloneFormVisible = true
        },
        isConfirmSet () {
          this.$refs.kpiForm.validate((valid) => {
            if (valid) {
              const data = {
                ...this.kpiForm,
                fields: this.$refs.dynamicTable.getData()
              }
              const nextTick = data.fields.every((item) => {
                if (item.xName === '' || item.xDesc === '' || item.yName === '' || item.yDesc === '' || item.format === '') {
                  this.$message({
                    message: this.$t('kpiMapping.fieldAlert'),
                    type: 'warning'
                  })
                  return false
                }
                return true
              })
              if (!nextTick) return
              if (!this.isAmend) {
                systemSettingBiz.addKpi(data).then((data) => {
                  setTimeout(() => {
                    this.searchKpi()
                    this.$message({
                      message: this.$t('common.success'),
                      type: 'success'
                    })
                    this.formVisible = false
                  }, 600)
                })
              } else {
                data.id = this.selectId
                systemSettingBiz.changeKpi(data).then((data) => {
                  setTimeout(() => {
                    this.searchKpi()
                    this.$message({
                      message: this.$t('common.success'),
                      type: 'success'
                    })
                    this.formVisible = false
                  }, 600)
                })
              }
            }
          })
        },
        isConfirmClone () {
          this.$refs.cloneFormA.validate((validA) => {
            this.$refs.cloneFormB.validate((validB) => {
              if (validA && validB) {
                this.cloneForm.cloneAlarm = this.cloneForm.cloneAlarm !== 'no'
                systemSettingBiz.cloneKpi(this.cloneForm).then((data) => {
                  setTimeout(() => {
                    this.searchKpi()
                    this.$message({
                      message: this.$t('common.success'),
                      type: 'success'
                    })
                    this.resetForm()
                  }, 1000)
                })
              }
            })
          })
        }
      },
      components: {
        dynamicTable
      },
      mounted () {
        this.e_init()
      },
      watch: {
        'form.group' () {
          this.waitAppList(this.form.siteCode, this.form.group, 1)
        },
        'form.siteCode': function (val) {
          this.waitGroupList(val, true, 1)
          this.form.group = ''
          this.form.appName = ''
        },
        'kpiForm.siteCode': function (val) {
          this.waitGroupList(val, true, 2)
        },
        'cloneForm.sourceSiteCode': function (val) {
          this.waitGroupList(val, true, 3)
        },
        'cloneForm.targetSiteCode': function (val) {
          this.waitGroupList(val, true, 4)
        },
        'kpiForm.group' () {
          this.waitAppList(this.kpiForm.siteCode, this.kpiForm.group, 2)
        },
        'cloneForm.sourceGroup' () {
          this.waitAppList(this.cloneForm.sourceSiteCode, this.cloneForm.sourceGroup, 3)
        },
        'cloneForm.targetGroup' () {
          this.waitAppList(this.cloneForm.targetSiteCode, this.cloneForm.targetGroup, 4)
        },
        'cloneForm.sourceAppName' () {
          this.e_getKpiKey()
        },
        isAmend (val) {
          this.dialogTitle = val ? this.$t('kpiMapping.change') : this.$t('kpiMapping.create')
        }
      }
    }
  </script>
      
  <style scoped>
    .kpiMapping__content .kpiMapping__operation {
      margin-bottom: 20px;
    }
    .kpiMapping__content .kpiMapping__dialog-body {
      overflow: hidden;
    }
    .kpiMapping__content .kpiMapping__dialog-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
    }
  </style>